module.exports = __webpack_public_path__ + "img/frame_degree_m_3.cf95dcaf.png";